import React, { Component } from 'react'
import { injectIntl, FormattedMessage, InjectedIntlProps } from 'react-intl'
import { autobind } from 'core-decorators'
import { Modal } from 'react-bootstrap/lib/'
import { observer } from 'mobx-react'
import classNames from 'classnames'
import GenevaButton from '../../../shared/components/GenevaButton'

import './AboutDialog.scss'

interface IAboutProps extends InjectedIntlProps {
  show: boolean,
  handleClose: Function,
}
interface IState {
  show: boolean
}

@observer
class About extends Component<IAboutProps> {
  OS: string
  state: IState

  constructor(props: IAboutProps) {
    super(props)
    this.state = {
      show: (props && props.show) || false,
    }

    this.OS = (navigator.appVersion.indexOf('Mac') !== -1)
      ? 'MacOS'
      : 'WindowsOS'

  }

  @autobind
  closeTranslationsModal(): void {
    this.props.handleClose()
  }

  render() {

    // future: make this more dynamic so it can be more easily used in other apps
    const displayData = {
      color: 'ff0000',
      short: 'rc',
      name: 'Review Center',
    }

    return (
      <Modal
        show={this.state.show}
        onHide={this.closeTranslationsModal}
        dialogClassName="aboutDialog"
      >

        <Modal.Body>
          <div className="about-dialog-main grid-block">
            <div className={classNames('appProduct logo', this.OS)}>
              GENEVA
            </div>
            <div className="appLink"
              style={{
                backgroundColor: `#${displayData.color}`
              }}
            >
              {displayData.short.toUpperCase()}
            </div>
            {displayData.name}
            <div className="version-wrapper">
              <label>
                <FormattedMessage id="about.version" />
                { global['VERSION'] }
              </label>
            </div>

            <GenevaButton
              className="small primary button"
              onClick={this.closeTranslationsModal}
            >
              <FormattedMessage id="about.close" />
            </GenevaButton>
            <div className="copyright">
              <FormattedMessage id="about.copyright" />
            </div>
          </div>
        </Modal.Body>
      </Modal>)
  }
}

export default injectIntl(About)
